import { useRef, useState } from "react";

// components
import { SortbyFilter } from "../SortbyFilter";

// assets
import { SvgCardCollection } from "assets/icons/js/SvgCardCollection";
import { SvgArrowDown } from "assets/icons/js/SvgArrowDown";

// helpers
import capitalizeFirstLetter from "helpers/cap";

// customHooks
import { useOnClickOutside } from "customHooks/useOnClickOutside";
import { useSearchQuery } from "customHooks/useQuery";
import { useMediaQuery } from "customHooks/useMediaQuery";

// styles
import "./styles.scss";
import axios from "axios";
import { axiosInstance } from "helpers/axiosInstance";

export const NameAndSortBy = ({ handleDrawer }: any) => {
	const [show, setShow] = useState(false);
	const spanRef = useRef(null);

	useOnClickOutside(spanRef, () => setShow(false));
	const query = useSearchQuery();

	const name =
		window.location.pathname?.split("/")[2]?.split("-")[2] !== "me" ? (
			<>
				{window.location.pathname?.split("/")[2]?.split("-")[2] ? (
					<>
						Villas in{" "}
						{capitalizeFirstLetter(
							window.location.pathname
								?.split("/")[2]
								?.split("-")[2]
								?.replace("%20", " "),
						)}
					</>
				) : (
					""
				)}
			</>
		) : (
			"Villas Near Me"
		);

	const selected = query.get("sortby") ? query.get("sortby") : "";

	const width = useMediaQuery();
	const isLaptopOrLower = width < 1080 ? true : false;

	const [location, setLocation] = useState(
		JSON.parse(
			sessionStorage.getItem("location") ||
				localStorage.getItem("location") ||
				"{}",
		)?.city || "",
	);

	const getLocation = async () => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(async function (position) {
				var latitude = position.coords.latitude;
				var longitude = position.coords.longitude;
				const res = await axiosInstance(
					`/get/location?lat=${latitude}&lon=${longitude}`,
				);
				setLocation(res.data?.data?.weatherInfo?.location?.name);
				const obj = {
					city: res.data?.data?.weatherInfo?.location?.name,
					lat: latitude,
					lon: longitude,
				};
				localStorage.setItem("location", JSON.stringify(obj));
				sessionStorage.setItem("location", JSON.stringify(obj));
				const url = new URLSearchParams(window.location.search);
				url.set("lat", latitude.toString());
				url.set("lon", longitude.toString());
				const newUrl = window.location.pathname + "?" + url.toString();
				window.history.pushState({ path: newUrl }, "", newUrl);
				window.location.reload();
			});
		} else {
			console.log("Geolocation is not supported by this browser.");
		}
	};

	return (
		<div className="name__and__sortby__container">
			<div className="left">
				<h2>{name}</h2>
				<span>
					{name === "Villas Near Me" && location && (
						<>
							{location} • Not here?{" "}
							<button onClick={getLocation} className="detect-location-btn">
								Detect my location
							</button>
						</>
					)}
				</span>
			</div>
			{!isLaptopOrLower && (
				<div
					className="right"
					ref={spanRef}
					style={{
						border: selected ? "2px solid #3564e2" : "1px solid #dddddd",
					}}
				>
					<span onClick={() => setShow((prev) => !prev)}>
						{selected ? `${selected}` : "Sort by"}
						<SvgArrowDown />
					</span>
					{show && <SortbyFilter handleClose={() => setShow(false)} />}
				</div>
			)}
			{isLaptopOrLower && (
				<div
					className="collection__div"
					ref={spanRef}
					onClick={() => handleDrawer(true)}
				>
					<span>
						<SvgCardCollection />
						<p>Collections</p>
					</span>
				</div>
			)}
		</div>
	);
};
